// THE CONSENT BANNER (STORE-08; D-23; plan 08A-27). The server draws the banner hidden and the same
// for every visitor; this controller shows it while the browser holds no answer and records the
// answer in a host-only cookie: `Path=/`, no `Domain`, `SameSite=Lax`, and `Secure` with the
// `__Host-` name the server hands over. «موافق» also tells the pixel loader to start, through a
// `storefront-consent:granted` event. The server reads the answer only at checkout, to decide whether
// a purchase may be reported (STORE-11; D-28).
//
// The footer's «إعدادات التتبّع» (D-30; window 775) carries this controller too, marked
// `data-storefront-consent-opener`: its `reopen` shows the banner again with the current answer
// pressed, so a visitor can withdraw. «رفض» then overwrites a granted answer, and the loader does not
// start on the next page.
import { Controller } from "@hotwired/stimulus"

export const GRANTED = "granted"
export const DENIED = "denied"

// Half a year, in seconds.
const MAX_AGE = 60 * 60 * 24 * 182

// The visitor's recorded answer, or null.
export function readConsent(name) {
  const prefix = `${name}=`
  const entry = document.cookie.split("; ").find((part) => part.startsWith(prefix))
  return entry ? entry.slice(prefix.length) : null
}

export default class extends Controller {
  static values = { cookie: String }
  static targets = ["answer"]

  connect() {
    if (this.opener) return
    if (readConsent(this.cookieValue) === null) this.element.hidden = false
  }

  get opener() {
    return this.element.hasAttribute("data-storefront-consent-opener")
  }

  // The footer button's action: the banner's own controller shows itself.
  reopen() {
    const banner = document.querySelector("[data-storefront-consent]")
    const consent = banner && this.application.getControllerForElementAndIdentifier(banner, this.identifier)
    if (consent) consent.show(this.element)
  }

  // The answer the browser holds is pressed and focused; focus returns to `returnTo` once answered.
  show(returnTo) {
    const current = readConsent(this.cookieValue)
    this.returnTo = returnTo
    this.answerTargets.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.answer === current)))
    this.element.hidden = false
    const pressed = this.answerTargets.find((button) => button.dataset.answer === current) || this.answerTargets[0]
    if (pressed) pressed.focus()
  }

  agree() {
    this.record(GRANTED)
    this.dispatch("granted")
  }

  refuse() {
    this.record(DENIED)
  }

  record(answer) {
    const secure = this.cookieValue.startsWith("__Host-") || window.location.protocol === "https:" ? "; Secure" : ""
    document.cookie = `${this.cookieValue}=${answer}; Path=/; Max-Age=${MAX_AGE}; SameSite=Lax${secure}`
    this.element.hidden = true
    if (this.returnTo) this.returnTo.focus()
    this.returnTo = null
  }
}
